<template>
</template>
<script>
	import axios from 'axios';  
	import { mapActions } from 'vuex';

	export default {
    components: {  },
    data: () => {
      return {}
    },
    mounted(){
    	// Primera carga
    	//console.log('dispatch getUserHash')
    	//this.$store.dispatch('getUserHash');

    	// On focus
    	window.addEventListener('focus', () => {
    		//console.log('dispatch checkUserHash');
    		this.$store.dispatch('checkUserHash')
    	})
    	/*window.onfocus = () => { 
    		console.log('dispatch');
    		//this.checkUserHash();
    		this.$store.dispatch('checkUserHash')
    	};*/
    },
    methods() {
      //...mapActions(['checkUserHash'])
    },
    methods:{
    }
  }
</script>